import { Link } from 'react-router-dom';
import { useState } from 'react';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '首页', path: '/' },
      { label: '分类浏览', path: '/category' },
      { label: '热门推荐', path: '/#hot' },
      { label: '最新更新', path: '/#latest' },
    ],
  },
  {
    title: '漫画分类',
    links: [
      { label: '恋爱漫画', path: '/category/love' },
      { label: '奇幻漫画', path: '/category/fantasy' },
      { label: '动作漫画', path: '/category/action' },
      { label: '悬疑漫画', path: '/category/suspense' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌故事', path: '/about' },
      { label: '用户口碑', path: '/about#reputation' },
      { label: '联系我们', path: '/about#contact' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '常见问题', path: '/about' },
      { label: '使用指南', path: '/about' },
      { label: '意见反馈', path: '/about#contact' },
    ],
  },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="mx-auto max-w-7xl">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
            <div className="lg:col-span-2">
              <Link to="/" className="inline-block cursor-pointer">
                <span className="font-heading text-2xl font-bold text-primary-400">
                  韩漫
                </span>
                <span className="font-heading text-2xl font-bold text-background-50">
                  漫画
                </span>
              </Link>
              <p className="mt-4 text-foreground-300 text-sm leading-relaxed max-w-sm">
                韩漫漫画网站是免费韩漫与漫画大全的宝库，提供海量在线漫画资源，持续为您挖掘和推荐好看的韩国漫画。
              </p>
              <form onSubmit={handleSubscribe} className="mt-6 flex items-center gap-0 max-w-sm">
                <div className="flex-1 relative">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="输入邮箱获取更新通知"
                    className="w-full h-11 pl-4 pr-4 bg-foreground-900 text-background-50 text-sm rounded-l-full outline-none border border-foreground-700 focus:border-primary-500 transition-colors"
                    required
                  />
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                </div>
                <button
                  type="submit"
                  className="h-11 px-5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-r-full flex items-center justify-center transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-notification-3-line text-lg"></i>
                </button>
              </form>
              {subscribed && (
                <p className="mt-3 text-sm text-primary-400">订阅成功！感谢您的关注。</p>
              )}
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                  {group.title}
                </h4>
                <ul className="space-y-3">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-14 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 韩漫漫画. All rights reserved.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-wechat-line', label: '微信' },
                { icon: 'ri-weibo-line', label: '微博' },
                { icon: 'ri-bilibili-line', label: 'B站' },
                { icon: 'ri-reddit-line', label: 'Reddit' },
              ].map((social) => (
                <a
                  key={social.label}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-lg border border-foreground-700 hover:border-primary-500 hover:text-primary-400 text-foreground-300 transition-colors cursor-pointer"
                  aria-label={social.label}
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-sm`}></i>
                </a>
              ))}
            </div>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                服务条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}